import './index.css';
import {
  Redirect,
  Route,
  Switch,
  type RouteComponentProps,
  useLocation,
} from 'wouter';
import { Header } from './components/Header';
import { About } from './components/About';
import { Footer } from './components/Footer';
import { LaplCreatorsInResidence } from './components/LaplCreatorsInResidence';
import { LosAngelesClock } from './components/LosAngelesClock';
import {
  ArchiveIndex,
  ArchiveProjectPage,
  getArchiveProjectBySlug,
} from './archive';
import { defaultWork, getWorkBySlug } from './works';
import { usePageViews } from './analytics/client';

function WorkPage({ params }: RouteComponentProps): JSX.Element {
  const work = getWorkBySlug(params.slug);

  if (!work) {
    return <Redirect to={`/works/${defaultWork.slug}`} replace />;
  }

  const { Component } = work;
  const header = (
    <Header
      title={
        <>
          <span className="font-light opacity-50">Works</span>
          {' / '}
          {work.title}
        </>
      }
    />
  );

  if (work.headerOverlaysContent) {
    return (
      <div className="relative min-h-dvh">
        <div className="absolute inset-x-0 top-0 z-10">{header}</div>
        <main className="relative flex h-dvh w-full items-center justify-center p-0">
          <Component />
        </main>
        <Footer currentWorkSlug={work.slug} />
      </div>
    );
  }

  return (
    <div className="flex min-h-dvh flex-col">
      {header}
      <main className="relative flex min-h-0 w-full flex-1 items-center justify-center p-0">
        <Component />
      </main>
      {work.hasBottomSpacer && (
        <div aria-hidden="true" className="h-[156px] shrink-0" />
      )}
      <Footer currentWorkSlug={work.slug} />
    </div>
  );
}

function ArchiveRoute({ params }: RouteComponentProps): JSX.Element {
  const project = getArchiveProjectBySlug(params.slug);

  if (!project) {
    return <Redirect to="/archive" replace />;
  }

  return <ArchiveProjectPage project={project} />;
}

export function App(): JSX.Element {
  const [location] = useLocation();
  usePageViews(location);
  const showClock = location !== '/proposals/lapl-creators-in-residence';

  return (
    <>
      <Switch>
        <Route path="/about" component={About} />
        <Route path="/archive/:slug" component={ArchiveRoute} />
        <Route path="/archive" component={ArchiveIndex} />
        <Route
          path="/proposals/lapl-creators-in-residence"
          component={LaplCreatorsInResidence}
        />
        <Route path="/bricking-my-phone">
          <Redirect to="/works/bricking-my-phone" replace />
        </Route>
        <Route path="/magnolia-flower">
          <Redirect to="/works/magnolia-flower" replace />
        </Route>
        <Route path="/works/as-the-day-burns">
          <Redirect to="/archive/as-the-day-burns" replace />
        </Route>
        <Route path="/works/project-ref">
          <Redirect to="/archive/as-the-day-burns" replace />
        </Route>
        <Route path="/works/:slug" component={WorkPage} />
        <Route path="/works">
          <Redirect to={`/works/${defaultWork.slug}`} replace />
        </Route>
        <Route path="/">
          <Redirect to={`/works/${defaultWork.slug}`} replace />
        </Route>
      </Switch>
      {showClock && <LosAngelesClock />}
    </>
  );
}

export default App;
